import { render, staticRenderFns } from "./GrupoPermissao.vue?vue&type=template&id=2dc87c0f&"
import script from "./GrupoPermissao.vue?vue&type=script&lang=js&"
export * from "./GrupoPermissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports